var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "widget-container" },
    [
      _c(_setup.WidgetBaseComponent, {
        ref: "widget",
        staticClass: "expedient-reminder-notes-widget",
        attrs: { loadedData: _setup.allDataLoaded && !_setup.showSpinner },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("div", { staticClass: "header-bar" }, [
                  _c("h2", [_vm._v(_vm._s(_setup.text.header))]),
                  _setup.canSave
                    ? _c("button", {
                        class: [_setup.icons.addButton, "add-button"],
                        on: { click: _setup.newNote },
                      })
                    : _vm._e(),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "widget-body" },
                  [
                    _setup.parsedNotes.length
                      ? _c(_setup.ReminderNotesContainerComponent, {
                          attrs: { notes: _setup.parsedNotes },
                          on: {
                            "edit-note": _setup.editNote,
                            "show-remove-dialog": _setup.showRemoveDialog,
                          },
                        })
                      : _c(_setup.EmptyNotesComponent),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(_setup.PromptDialogComponent, {
        attrs: {
          width: 940,
          title: "Nueva nota",
          isOpened: _setup.isOpenedDialog,
          formSchema: _setup.formSchema,
          context: "sso-payments",
          formFieldValues: _setup.formFieldValues,
        },
        on: { "execute-action": _setup.executeDialogAction },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }